<template>
  <div>
    <em-header headline="Select Material Type">
      <em-action-button
        :action="save"
        :disabled="!hasSelection"
      >
        Choose Type
      </em-action-button>
    </em-header>

    <div
      class="cards"
      :class="{locked}"
    >
      <div
        v-for="type in materialTypes"
        :key="type.key"
        class="container"
        :class="cardCssClasses(type)"
        @click="select(type.key)"
      >
        <el-card
          shadow="hover"
          class="card"
        >
          <img :src="type.thumbnail">

          <div class="details">
            <!--<span class="group">{{ type.group }}</span>-->
            <span class="label">{{ type.label }}</span>
          </div>
        </el-card>
      </div>
      <div
        v-if="!materialTypes.length"
        class="no-results"
      >
        <span>Oh no - we did not find any matching Material Types :(</span>
      </div>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
  .cards
    display flex
    flex-wrap wrap
    justify-content space-around

    .container
      display flex
      padding var(--gap)
      max-width 350px
      min-width 200px
      cursor pointer

      &:hover, &.selected
        img
          filter: blur(1px)

        .card .details
          opacity 1

      &.selected
        .card .details
          background var(--color-overlay-selected)

          span
            background: rgba(255, 255, 255, .25)

      .card
        display flex
        justify-content center
        align-items center
        position relative
        color: var(--color-text)

        img
          width 100%

        /deep/ .el-card__body
          padding var(--gap)

        .details
          transition all ease-in-out 250ms
          position absolute
          display flex
          flex-direction column
          justify-content center
          align-items center
          top 0
          left 0
          height 100%
          width 100%
          pointer-events none
          opacity 0
          background var(--color-overlay)

          span
            display block
            font-size 1.2rem
            color #fff
            padding 6px 16px
            border-radius 8px

  .cards.locked .container:not(.selected):hover
    img
      filter none

    .card .details
      opacity 0

</style>

<script>
  import stopsLoading from '../../lib/mixins/stopsLoading'
  import EmHeader from '../../components/EmHeader'
  import EmActionButton from '../../components/EmActionButton'
  import { mapActions } from 'vuex'
  import router from '../../router'

  export default {
    name: 'SelectType',
    components: { EmActionButton, EmHeader },
    mixins: [
      stopsLoading
    ],

    props: {
      materialTypes: {
        type: Array,
        required: true
      },
      material: {
        type: Object
      }
    },

    data () {
      return {
        selected: null,
        locked: false
      }
    },

    computed: {
      hasSelection () {
        return !!this.selected
      }
    },

    created () {
      if (this.material && this.material.material_type_id) {
        this.selected = this.material.material_type_id
        this.save()
        router.push({ name: 'loading' })
      }
    },

    methods: {
      ...mapActions('steps', [
        'execute',
        'mergeToState'
      ]),

      select (key) {
        if (this.locked) {
          return
        }

        this.selected = key
      },

      save () {
        this.locked = true

        // update the step state
        this.mergeToState({
          material_type_id: this.selected
        })

        return this.execute()
          .catch(error => {
            router.push({
              name: 'failure',
              params: { error }
            })
          })
      },

      cardCssClasses (type) {
        return {
          selected: this.selected === type.key
        }
      }
    }
  }
</script>
